import "./style.scss";

import AlertTriangle from "assets/img/svg/alertTriangle";
import { Pending } from "components/Management/ModalContent";
import ModalBox from "components/Modal";
import StyledButton from "components/shared/StyledButton";
import { StyledMenuItem, StyledSelect } from "components/shared/StyledSelect";
import { useState } from "react";
import type { Job, ProcessingJobStatus } from "store/jobsStore";

import { status } from "../ImportTracking";

type TProps = {
    processingJob: Job;
    close: (success: boolean) => void;
    onChangeStatus: (status: ProcessingJobStatus) => Promise<unknown>;
};
const ChangeProcessingJobStatus = ({ processingJob, close, onChangeStatus }: TProps) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState<ProcessingJobStatus>(processingJob.status);

    const handleClick = async () => {
        setIsProcessing(true);
        await onChangeStatus(selectedStatus);
        setIsProcessing(false);
        close(true);
    };

    return (
        <>
            <ModalBox open={isProcessing} onClose={() => {}} showCloseButton={false}>
                <Pending phrase={"Mise à jour du statut..."} />
            </ModalBox>
            <div className="delete-key-wrapper">
                <div className="delete-key-alert">
                    <h3 className="delete-key-alert-sales">Quel statut souhaitez-vous appliquer ?</h3>
                    <div className="delete-key-alert-message">
                        <AlertTriangle />
                        Cette action n‘annulera pas l‘import s‘il est toujours en cours.
                    </div>
                </div>
                <div className="delete-key-description">
                    Cet espace est utile afin de débloquer une situation où un import n‘aurait pas pu aboutir et serait
                    bloqué dans un statut en cours de traitement.
                    <br />
                    <br />
                    Si l‘import est toujours en cours, merci de ne pas utiliser cette fonctionnalité.
                </div>
                <StyledSelect name="status" fullWidth value={selectedStatus}>
                    {status.map((status, idx) => (
                        <StyledMenuItem onClick={() => setSelectedStatus(idx)} key={status} value={idx}>
                            <span style={{ marginLeft: "8px" }}>{status}</span>
                        </StyledMenuItem>
                    ))}
                </StyledSelect>
                <div className="delete-key-buttons">
                    <StyledButton buttonType="primary" fullWidth onClick={handleClick}>
                        Mettre à jour
                    </StyledButton>
                </div>
            </div>
        </>
    );
};
export default ChangeProcessingJobStatus;
